export const CONTAINER_WIDTH = 1100;